export enum RaffleUserRole {
    ADMIN,
    ACCOUNT_MANAGER,
    SELLER,
    ACCOUNT_MANAGER_AND_SELLER
  }
  